import { useState, useEffect } from "react";
import CrearContrato from "../../../pages/crearContrato/CrearContrato";
import { Link, useLocation} from "react-router-dom";
export default function Clientes() {
    const [show, setShow] = useState(false);
    const location = useLocation();
    const showModal = location.state && location.state.showModal;

    useEffect(() => {
        if (showModal) {setShow(true);}
    }, [showModal]);
    return (
        <>
            <div className="pt-3">
                <h1 className="text-gray-800 fw-bold fs-1">
                    Clientes
                </h1>
                <div className="pt-4">
                    <Link to={'/contrato/crear-contrato'}
                          state={{ showModal: true }}
                          className={"btn w-100 text-start custom-list d-flex bg-primary bg-hover-primary-active rounded-1 align-items-center px-5 py-4"}
                    >
                        <div className="symbol symbol-50px me-5">
                            <span className="symbol-label bg-white">
                                <i className="ki-outline ki-feather fs-1 text-primary"></i>
                            </span>
                        </div>
                        <div className="d-flex flex-column fw-bold flex-grow-1">
                            <h5 className="custom-list-title fw-semibold text-gray-200 mb-0">
                                Crear Contrato
                            </h5>
                            <span className="text-gray-200 fw-semibold d-none d-sm-none d-md-none d-lg-block fs-base">
                                S&oacute;lo nuevos servicios.
                            </span>
                        </div>
                    </Link>
                    <CrearContrato show={show} setShow={setShow}></CrearContrato>
                    {/*<form action="#">*/}
                    {/*    <div className="separator separator-dashed my-8"></div>*/}
                    {/*    <div className="position-relative">*/}
                    {/*        <i className="ki-duotone ki-magnifier fs-3 text-gray-500 position-absolute top-50 translate-middle ms-6">*/}
                    {/*            <span className="path1"></span>*/}
                    {/*            <span className="path2"></span>*/}
                    {/*        </i>*/}
                    {/*        <input type="text" className="form-control form-control-solid ps-10" name="search" value=""*/}
                    {/*               placeholder="Search"/>*/}
                    {/*    </div>*/}
                    {/*    <div className="separator separator-dashed my-8"></div>*/}
                    {/*    <div className="mb-5">*/}
                    {/*        <label className="fs-6 form-label fw-bold text-gray-900">Team Type</label>*/}
                    {/*        <select className="form-select form-select-solid" data-control="select2"*/}
                    {/*                data-placeholder="In Progress" data-hide-search="true">*/}
                    {/*            <option value=""></option>*/}
                    {/*            <option value="1">Not Started</option>*/}
                    {/*            <option value="2" selected="selected">In Progress</option>*/}
                    {/*            <option value="3">Done</option>*/}
                    {/*        </select>*/}
                    {/*    </div>*/}
                    {/*    <div className="mb-5">*/}
                    {/*        <label className="fs-6 form-label fw-bold text-gray-900">Team Name</label>*/}
                    {/*        <input type="text" className="form-control form-control form-control-solid" name="city"/>*/}
                    {/*    </div>*/}
                    {/*    <div className="mb-5">*/}
                    {/*        <label className="fs-6 form-label fw-bold text-gray-900">Team Size</label>*/}
                    {/*        <div className="nav-group nav-group-fluid">*/}
                    {/*            <label>*/}
                    {/*                <input type="radio" className="btn-check" name="type" value="has"*/}
                    {/*                       checked="checked"/>*/}
                    {/*                <span*/}
                    {/*                    className="btn btn-sm btn-color-muted btn-active btn-active-primary fw-bold px-4">1-5</span>*/}
                    {/*            </label>*/}
                    {/*            <label>*/}
                    {/*                <input type="radio" className="btn-check" name="type" value="users"/>*/}
                    {/*                <span*/}
                    {/*                    className="btn btn-sm btn-color-muted btn-active btn-active-primary fw-bold px-4">5-10</span>*/}
                    {/*            </label>*/}
                    {/*            <label>*/}
                    {/*                <input type="radio" className="btn-check" name="type" value="orders"/>*/}
                    {/*                <span*/}
                    {/*                    className="btn btn-sm btn-color-muted btn-active btn-active-primary fw-bold px-4">10++</span>*/}
                    {/*            </label>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className="mb-5">*/}
                    {/*        <label className="fs-6 form-label fw-bold text-gray-900">Max. Amount</label>*/}
                    {/*        <div className="position-relative">*/}
                    {/*            <button type="button" className="btn btn-icon btn-active-color-gray-700 position-absolute translate-middle-y top-50 start-0">*/}
                    {/*                <i className="ki-duotone ki-minus-circle fs-1">*/}
                    {/*                    <span className="path1"></span>*/}
                    {/*                    <span className="path2"></span>*/}
                    {/*                </i>*/}
                    {/*            </button>*/}
                    {/*            <input type="text" className="form-control form-control-solid border-0 ps-12" readOnly="readonly" value="$50"/>*/}
                    {/*            <button type="button" className="btn btn-icon btn-active-color-gray-700 position-absolute translate-middle-y top-50 end-0">*/}
                    {/*                <i className="ki-duotone ki-plus-circle fs-1">*/}
                    {/*                    <span className="path1"></span>*/}
                    {/*                    <span className="path2"></span>*/}
                    {/*                </i>*/}
                    {/*            </button>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className="mb-10">*/}
                    {/*        <label className="fs-6 form-label fw-bold text-gray-900 mb-5">Categories</label>*/}
                    {/*        <div className="form-check form-check-custom form-check-solid mb-5">*/}
                    {/*            <input className="form-check-input" type="checkbox" id="kt_search_category_1"/>*/}
                    {/*            <label className="form-check-label flex-grow-1 fw-semibold text-gray-700 fs-6" htmlFor="kt_search_category_1">Electronics</label>*/}
                    {/*            <span className="text-gray-500 fw-bold">28</span>*/}
                    {/*        </div>*/}
                    {/*        <div className="form-check form-check-custom form-check-solid mb-5">*/}
                    {/*            <input className="form-check-input" type="checkbox" id="kt_search_category_2" checked="checked"/>*/}
                    {/*            <label className="form-check-label flex-grow-1 fw-semibold text-gray-700 fs-6" htmlFor="kt_search_category_2">Sport Equipments</label>*/}
                    {/*            <span className="text-gray-500 fw-bold">307</span>*/}
                    {/*        </div>*/}
                    {/*        <div className="form-check form-check-custom form-check-solid">*/}
                    {/*            <input className="form-check-input" type="checkbox" id="kt_search_category_3"/>*/}
                    {/*            <label className="form-check-label flex-grow-1 fw-semibold text-gray-700 fs-6" htmlFor="kt_search_category_3">Furnuture</label>*/}
                    {/*            <span className="text-gray-500 fw-bold">54</span>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className="d-flex align-items-center justify-content-end">*/}
                    {/*        <button className="btn btn-active-light-primary btn-color-gray-500 me-3">Discard</button>*/}
                    {/*        <button className="btn btn-primary">Search</button>*/}
                    {/*    </div>*/}
                    {/*</form>*/}
                </div>
            </div>
        </>
    );
}
